"use client";

import { useCallback, useEffect, type RefObject } from "react";

/** Close an open popover when the page or tag strip scrolls. */
export function useDismissPopoverOnScroll(
  open: boolean,
  onDismiss: () => void,
  scrollContainerRef?: RefObject<HTMLElement | null>
) {
  const dismiss = useCallback(() => onDismiss(), [onDismiss]);

  useEffect(() => {
    if (!open) return;

    window.addEventListener("scroll", dismiss, true);
    window.addEventListener("resize", dismiss);

    const el = scrollContainerRef?.current;
    el?.addEventListener("scroll", dismiss, { passive: true });

    return () => {
      window.removeEventListener("scroll", dismiss, true);
      window.removeEventListener("resize", dismiss);
      el?.removeEventListener("scroll", dismiss);
    };
  }, [open, dismiss, scrollContainerRef]);
}
